<template>
  <div class="card">
    <div class="card-body">
      <div class="row mb-3">
        <div class="col-lg-12 text-end">
          <v-btn color="success darken-2" text small @click="openNewStockCategoryDialog()"
            ><v-icon small left>mdi-plus</v-icon> Stok Kategorisi Ekle</v-btn
          >
        </div>
        <div class="col-lg-12 d-flex flex-wrap">
          <div class="ms-auto">
            <v-text-field
              class="mt-5 pt-3"
              outlined
              rounded
              dense
              placeholder="Arama Yapın..."
              clearable
              hide-details
              append-icon="mdi-magnify"
              @click:append="_fetchStockCategoryList"
              @keydown.enter="_fetchStockCategoryList"
            ></v-text-field>
          </div>
        </div>
      </div>
      <div class="row">
        <ResultTableView
          :perPage="perPage"
          :currentPage="currentPage"
        ></ResultTableView>
      </div>
      <!-- end row -->
    </div>

    <EditStockCategoryDialog
      :stockCategoryProp="stockCategory"
      :processType="'new'"
      :showDialog="newStockCategoryDialog"
      @dialogChange="(data) => (newStockCategoryDialog = data)"
    ></EditStockCategoryDialog>
  </div>
</template>

<script>
import ResultTableView from "@/components/management/stock-categories/results/ResultsTableView.vue";

import EditStockCategoryDialog from "@/components/management/stock-categories/dialogs/EditStockCategoryDialog.vue";

import { mapState, mapActions } from "vuex";

export default {
  components: {
    ResultTableView,
    EditStockCategoryDialog,
  },
  created() {
    this._fetchStockCategoryList();
  },
  computed: {
    ...mapState("stock", ["stockCategoryList"]),
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      showNewUserDialog: false,
      stockCategory:null,
      newStockCategoryDialog: false
    };
  },
  methods: {
    ...mapActions("stock", ["fetchStockCategoryList"]),
    async _fetchStockCategoryList(){
      await this.fetchStockCategoryList({
        params:{},
        body:{},
        saltData: false
      });
    },
    searchClicked() {
    },
    openNewStockCategoryDialog(){
      this.newStockCategoryDialog = true;
    }
  },
};
</script>
